import * as React from "react";
import tw, { styled } from "twin.macro";
import { Button } from "~/features/ui/button";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import Loading from "~/public/icons/loading.svg";
import ArrowDown from "~/public/icons/arrow-down.svg";

type Props = {
  isLoading: boolean;
};

const LoadMoreButton = styled.button`
  ${tw`w-full flex items-center justify-center py-xl`}
`;

export function LoadMore(props: Props & React.ComponentPropsWithRef<"button">) {
  const { isLoading, ...rest } = props;
  getThemeStyle({ mode: "light" });
  const hoverId = "load-more-hover";

  return (
    <LoadMoreButton id={hoverId} {...rest}>
      <Button as="div" variant="underline" icon={isLoading ? Loading : ArrowDown} hoverId={hoverId}>
        {isLoading ? "Loading" : "Load More"}
      </Button>
    </LoadMoreButton>
  );
}
